import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PdfItem from 'src/pdf/PdfAll'

export default function ContenidoPdf({ file }) {
    const [pdf, setPdf] = useState(null)
    useEffect(() => {
        if (file !== null) {
            setPdf(file)
        }
    }, [file])
    return (
        <>{
            file !== null &&
            <Box style={{ maxWidth: "550px", overflowX: "scroll", overflowY: "scroll", scrollTop: "0 !important", transform: "scale(0.7)", marginTop: "-150px" }}>
                <PdfItem
                    pdf={pdf}
                />
            </Box>
        }</>
    )
}
